import React from "react";
import { Row, Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SearchLg from "@untitled-ui/icons-react/build/esm/SearchLg";
/**
 * Reusable Search and Filter component
 *
 * Props:
 * - searchText: string
 * - onSearchChange: (value: string) => void  function to change the search input e.g onSearchChange(e.target.value)
 * - selectValue: string
 * - onSelectChange: (value: string) => void
 * - selectOptions: { label: string; value: string }[]
 * - placeholder?: string
 * - inputWidth?: number
 * - selectWidth?: number
 * - style?: CSSProperties
 */

const TableSearchFilter = ({
  searchText,
  onSearchChange,
  selectValue,
  onSelectChange,
  selectOptions,
  searchPlaceholder = "Search...",
  inputWidth = 320,
  selectWidth = 250,
  style = {},
}) => {
  return (
    <Row>
      <div style={{ margin: "0px 5px" }}>
        <Input
          placeholder={searchPlaceholder}
          style={{
            width: inputWidth,
            borderColor: "#D0D5DD",
            borderRadius: 10,
            height: 36,
          }}
          value={searchText}
          onChange={onSearchChange}
          prefix={<SearchLg width={18} color="#667085" />}
        />
      </div>
      <div style={{ marginBottom: "auto", marginLeft: 10 }}>
        <Select
          value={selectValue}
          onChange={onSelectChange}
          options={selectOptions}
          dropdownStyle={{ width: "250px" }}
          className="interbank-table-select"
        />
      </div>
    </Row>
  );
};

export default TableSearchFilter;
